module.exports = __webpack_public_path__ + "img/UmbrellasNShades.cdaea780.png";